export  const scaleGizmoColor = "#DC143C";

export  const xGizmoColor = "#ff3c3c";
export  const yGizmoColor = "#2E8B57";
export  const zGizmoColor = "#004C8C";

export  const xColor = "#ff5e5e";
export  const yColor = "#3CB371";
export  const zColor = "#1E90FF";
